import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authToken: null,
    selectedSchedule: null,
    selectedPeriod: null,
    confirmationDialogMessage: null,
    loading: { value: false, isReload: false },
    revisoesConfiguracao: {},
    conflitoRevisao: null,
  },
  getters: {
    loading(state) {
      return state.loading.value;
    },
    loadingFromReload(state) {
      return state.loading.isReload;
    },
  },
  mutations: {
    SET_AUTH_TOKEN(state, token) {
      state.authToken = token;
    },
    CLEAR_AUTH_TOKEN(state) {
      state.authToken = null;
      state.revisoesConfiguracao = {};
      state.conflitoRevisao = null;
    },
    SET_SELECTED_SCHEDULE(state, scheduleId) {
      state.selectedSchedule = scheduleId;
    },
    SET_SELECTED_PERIOD(state, periodId) {
      state.selectedPeriod = periodId;
    },
    SET_CONFIRMATION_DIALOG_MESSAGE(state, message) {
      state.confirmationDialogMessage = message;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    setRevisaoConfiguracao(state, { id, revisao }) {
      Vue.set(state.revisoesConfiguracao, id, revisao);
    },
    removerRevisaoConfiguracao(state, id) {
      Vue.delete(state.revisoesConfiguracao, id);
    },
    setConflitoRevisao(state, valor) {
      state.conflitoRevisao = valor;
    },
  },
  actions: {
    setAuthToken({ commit }, token) {
      commit("SET_AUTH_TOKEN", token);
      localStorage.setItem("authToken", token);
    },
    clearAuthToken({ commit }) {
      localStorage.removeItem("authToken");
      commit("CLEAR_AUTH_TOKEN");
    },
    setSelectedSchedule({ commit }, scheduleId) {
      commit("SET_SELECTED_SCHEDULE", scheduleId);
    },
    setSelectedPeriod({ commit }, periodId) {
      commit("SET_SELECTED_PERIOD", periodId);
    },
    setConfirmationDialogMessage({ commit }, message) {
      commit("SET_CONFIRMATION_DIALOG_MESSAGE", message);
    },
    setLoading({ commit }, reload) {
      commit("SET_LOADING", { value: true, isReload: reload });
    },
    clearLoading({ commit }) {
      commit("SET_LOADING", { value: false, isReload: false });
    },
  },
  modules: {},
});
